import React from 'react';

const UserDisabledIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
      fill="#001C3D"
      fillOpacity="0.08"
    />
    <path
      d="M18.3487 5.64164C18.5466 5.83421 18.5509 6.15076 18.3584 6.34868L6.35836 18.682C6.16579 18.8799 5.84924 18.8843 5.65132 18.6917C5.4534 18.4991 5.44907 18.1826 5.64164 17.9847L6.86104 16.7314C6.86014 16.7275 6.85925 16.7237 6.85837 16.7199C6.71576 16.0986 6.86513 15.4074 7.21334 14.8155L7.65452 14.0656C8.10372 13.3021 8.92342 12.8333 9.80927 12.8333H10.6537L11.6458 11.8137C10.0636 11.6376 8.83333 10.2958 8.83333 8.66667C8.83333 6.91776 10.2511 5.5 12 5.5C13.5995 5.5 14.922 6.68582 15.1363 8.22626L17.6416 5.65132C17.8342 5.4534 18.1508 5.44907 18.3487 5.64164Z"
      fill="#9DA4AE"
    />
    <path
      d="M15.7747 18.0917C13.695 18.6289 10.4179 18.636 8.30672 18.1129L13.4436 12.8333H14.1883C15.0742 12.8333 15.8939 13.3021 16.3431 14.0656L16.7843 14.8155C17.1325 15.4074 17.2818 16.0986 17.1392 16.7199C16.9904 17.3683 16.5293 17.8967 15.7747 18.0917Z"
      fill="#9DA4AE"
    />
  </svg>
);

export default UserDisabledIcon;
